/*
 * Public API Surface of modal
 */

export * from './lib/modal.types';
export * from './lib/modal.component';
export * from './lib/modal.module';
